import axios from 'axios';
import moment from 'moment';

import { getFromToDates } from '../components/Common/cleanDates';
import { getLocalStorageData } from '../reducers/headerRedux';
import {
  REQUEST_PO_PDF,
  FETCH_PO_PDF_SUCCESS,
  REQUEST_SI_PDF,
  FETCH_SI_PDF_SUCCESS,
  FETCH_SI_PDF_FAILURE,
  REQUEST_SI_RETURN_PDF,
  FETCH_SI_RETURN_PDF_SUCCESS,
  FETCH_SI_RETURN_PDF_FAILURE,
  REQUEST_WR_PDF,
  FETCH_WR_PDF_SUCCESS,
  REQUEST_AR_PDF,
  FETCH_AR_PDF_SUCCESS,
  REQUEST_AP_PDF,
  FETCH_AP_PDF_SUCCESS,
  REQUEST_PURCHASE_RETURN_PDF,
  FETCH_PURCHASE_RETURN_PDF_SUCCESS,
  REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL,
  REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS,
  REQUEST_PURCHASE_REFERENCE_PDF,
  FETCH_PURCHASE_REFERENCE_PDF_SUCCESS,
  REQUEST_ROUTING_PDF_SUCCESS,
  REQUEST_ROUTING_PDF_FAILURE,
  REQUEST_ROUTING_PDF,
  REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS,
  REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE,
  REQUEST_DISPATCH_PICKING_LIST_PDF,
  REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS,
  REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE,
  REQUEST_DISPATCH_PACKING_LIST_PDF,
  REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS,
  REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE,
  REQUEST_DISPATCH_SALES_INVOICE_PDF,
  REQUEST_PO_NOSUBTOTAL_PDF,
  REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_SI_NOSUBTOTAL_PDF,
  REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_SI_RETURN_NOSUBTOTAL_PDF,
  REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS,
  REQUEST_COMMERCIAL_INVOICE_PDF,
  REQUEST_COMMERCIAL_INVOICE_PDF_SUCCESS,
  REQUEST_COMMERCIAL_INVOICE_PDF_FAILURE
} from './type';
import {
  PURCHASE_ORDER_PRINT_URL,
  SALES_INVOICE_PRINT_URL,
  SALES_INVOICE_RETURN_PRINT_URL,
  WAREHOUSE_RECEIVE_PRINT_URL,
  AR_PRINT_URL,
  AR_PRINT_PLAIN_URL,
  AP_PRINT_URL,
  PURCHASE_RETURNS_URL,
  PURCHASE_URL,
  DISPATCH_URL,
  PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL,
  SALES_INVOICE_PRINT_NOSUBTOTAL_URL,
  SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL,
  PURCHASE_RETURNS_NO_SUBTOTALS,
  RECEIVE_URL,
  AR_AGED_PRINT_URL,
  ROOT_URL_V2,
} from './url';
import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI, isLAP, isUSPrideMulti, isAPD, isVAK, isOLG, isGFD} from './root_url'
import { I18n } from 'react-redux-i18n';
import { isDst } from '../components/Common/NumberUtil';


export function printPurchaseOrder(purchaseOrderID) {
  let url = `${PURCHASE_ORDER_PRINT_URL}print/${purchaseOrderID}`;
  if(isVAK) {
    const languageBoolean = I18n._locale === "en" ? "True" : "False";
    url += `?IsEnglish=${languageBoolean}`
  }
  if(isOLG) {
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    if(sq > 0 && isDst()) {
      sq+=60;
      let zone = -sq / 60;
      url += `?time_zone=${zone}&time_diff=${time}`;
    } else {
      url += `?time_zone=${(time)}&time_diff=${time}`;
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_PO_PDF });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrderPDFSuccess(response));
      }, (err) => {
        dispatch(fetchPurchaseOrderPDFSuccess(err));
        console.log('ERROR IN response', err);
      });
  };
}

function fetchPurchaseOrderPDFSuccess(FileData) {
  return {
    type: FETCH_PO_PDF_SUCCESS,
    payload: FileData,
  };
}

function fetchPurchaseReturnPDFSuccess(fileData) {
  return {
    type: FETCH_PURCHASE_RETURN_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printPurchaseOrderNoSubtotals(purchaseOrderID) {
  let url = `${PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL}` + purchaseOrderID;
  if(isVAK) {
    const languageBoolean = I18n._locale === "en" ? "True" : "False";
    url += `?IsEnglish=${languageBoolean}`
  }
  if(isOLG) {
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    if(sq > 0 && isDst()) {
      sq+=60;
      let zone = -sq / 60;
      url += `?time_zone=${zone}&time_diff=${time}`;
    } else {
      url += `?time_zone=${(time)}&time_diff=${time}`;
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_PO_NOSUBTOTAL_PDF });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printPurchaseOrderNoSubtotalsSuccess(response));
    }, (err) => {
      console.log('Print Error', err);
    });
  };
}

export function printPurchaseOrderNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printPurchaseReturn(purchaseReturnID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_RETURN_PDF });
    let url = `${PURCHASE_RETURNS_URL}print/${purchaseReturnID}`;
    if(isOLG) {
      let sq = new Date().getTimezoneOffset();
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `?time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `?time_zone=${(time)}&time_diff=${time}`;
      }
    }
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchPurchaseReturnPDFSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}

function fetchPurchaseReferencePDFSuccess(fileData) {
  return {
    type: FETCH_PURCHASE_REFERENCE_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printPurchaseReference({ typeradio, group, category, endTime }) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_REFERENCE_PDF });
    return axios({
      method: 'get',
      url: `${PURCHASE_URL}referenceguide/print/${typeradio}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        ProductGroup_id: group,
        ProductCategory1_id: category,
        end_time: endTime,
      },
    }).then((response) => {
      dispatch(fetchPurchaseReferencePDFSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}

export function printPickup(purchaseOrderID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PO_PDF });
    return axios.get(
      `${PURCHASE_ORDER_PRINT_URL}pickupprint/${purchaseOrderID}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPrintPickupSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

function fetchPrintPickupSuccess(FileData) {
  return {
    type: FETCH_PO_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printSalesInvoice(salesInvoiceID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SI_PDF });
    let url = SALES_INVOICE_PRINT_URL + salesInvoiceID;
    if(isOLG) {
      let sq = new Date().getTimezoneOffset();
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `?time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `?time_zone=${(time)}&time_diff=${time}`;
      }
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesInvoicePdfSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSalesInvoicesPdfFailure(err));               
        }
      });
  };
}

export function printSalesInvoiceReturn(salesInvoiceReturnID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SI_RETURN_PDF });
    return axios.get(
      SALES_INVOICE_RETURN_PRINT_URL + salesInvoiceReturnID,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        console.log(response);
        dispatch(fetchSalesInvoiceReturnPdfSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSalesInvoicesReturnPdfFailure(err));               
        }
      });
  };
}

export function printSalesInvoiceNoSubtotals(salesInvoiceId) {
  return (dispatch) => {
    dispatch({type: REQUEST_SI_NOSUBTOTAL_PDF});
    return axios.get(
      SALES_INVOICE_PRINT_NOSUBTOTAL_URL + salesInvoiceId,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printSalesInvoiceNoSubtotalsSuccess(response))
    }, (err) => {
      console.log('Print Error', err);
    });
  };
}

export function printSalesInvoiceNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS,
    payload: fileData,
  };
}

export function printSalesInvoiceReturnsNoSubtotals(salesInvoiceId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SI_RETURN_NOSUBTOTAL_PDF });
    return axios.get(
      SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL + salesInvoiceId,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printSalesInvoiceReturnNoSubtotalsSuccess(response))
    }, (err) => {
      console.log('Print Error', err);
    });
  };
}

export function printSalesInvoiceReturnNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchSalesInvoicePdfSuccess(FileData) {
  return {
    type: FETCH_SI_PDF_SUCCESS,
    payload: FileData,
  };
}

export function fetchSalesInvoicesPdfFailure(error) {
  return {
    type: FETCH_SI_PDF_FAILURE,
    payload: error,
  };
}

function fetchSalesInvoiceReturnPdfSuccess(FileData) {
  return {
    type: FETCH_SI_RETURN_PDF_SUCCESS,
    payload: FileData,
  };
}

export function fetchSalesInvoicesReturnPdfFailure(error) {
  return {
    type: FETCH_SI_RETURN_PDF_FAILURE,
    payload: error,
  };
}

export function printWarehouseReceive(warehouseReceiveNum) {
  return (dispatch) => {
    dispatch({ type: REQUEST_WR_PDF });
    let url = WAREHOUSE_RECEIVE_PRINT_URL + warehouseReceiveNum;
    if(isOLG) {
      let sq = new Date().getTimezoneOffset();
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `?time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `?time_zone=${(time)}&time_diff=${time}`;
      }
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchWarehouseReceiveSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printWarehouseReceiveNoSubtotals(warehouseReceiveNum) {
  return (dispatch) => {
    dispatch({ type: REQUEST_WR_PDF });
    let url = WAREHOUSE_RECEIVE_PRINT_URL + 'no_price/' + warehouseReceiveNum;
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchWarehouseReceiveSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printBundleBarcode(pks) {
  return (dispatch) => {
    dispatch({ type: REQUEST_WR_PDF });
    return axios.get(
      `${ROOT_URL_V2}purchase/invoice-line/print-bundle-barcode/${pks}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchWarehouseReceiveSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export const fetchLineLabel = (WarehouseReceive_id, WarehouseReceiveLine_id) => dispatch => {
  dispatch({ type: REQUEST_WR_PDF });
  axios.get(
    `${RECEIVE_URL}print_label/${WarehouseReceive_id}/${WarehouseReceiveLine_id}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    },
  )
    .then((response) => {
      dispatch(fetchWarehouseReceiveSuccess(response));
    }, (err) => {
      console.log('ERROR IN response', err);
    });
}

function fetchWarehouseReceiveSuccess(FileData) {
  return {
    type: FETCH_WR_PDF_SUCCESS,
    payload: FileData,
  };
}

/*
  makes a get request for an AR report and signals for success and failure
  params:
    customerId: number,
    fromDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    toDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    cutoffDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    isSimplified: boolean
  returns:
    function for thunk middleware
*/


function fetchARReportSuccess(fileData) {
  return {
    type: FETCH_AR_PDF_SUCCESS,
    payload: fileData,
  };
}

export const printSalesInvoiceForCustomerStatement = invoiceId => (dispatch) => {
  dispatch({ type: REQUEST_AR_PDF });
  return axios({
    method: 'get',
    url: `${SALES_INVOICE_PRINT_URL}${invoiceId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  })
    .then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(DEFAULT_ERROR));             
      }
    });
}

export function printARReport(customerId, fromDate, toDate, cutoffDate, isSimplified, isSendEmail = false, email = '', subject = '', content = '') {
  const mode = isSimplified ? 'simplifiedprint' : 'print';
  return (dispatch) => {
    dispatch({ type: REQUEST_AR_PDF });
    let params = {
      start_date: fromDate,
      end_date: toDate,
      cut_off_date: cutoffDate,
    }
    if(isSendEmail && isSimplified) {
      params.is_send_email = 1;
      params.to_email = email;
      params.subject = subject;
      params.content = content;
    }
    let sq = new Date().getTimezoneOffset();
    if(isLAP || isUSPrideMulti || isAPD || isOLG) {
      params.time_zone = (-sq / 60)
    }
    
    const activeWarehouse =  getLocalStorageData('selectedWarehouse');
    if (isGFD && activeWarehouse) {
      params.warehouse_id = activeWarehouse.value;
    }
    
    if(isOLG) {
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        params.time_zone = zone;
      } else {
        params.time_zone = time;
      }
      params.time_diff = time
    }
    return axios({
      method: 'get',
      url: `${AR_PRINT_URL}${customerId}/${mode}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params,
    }).then((response) => {
      if(isSendEmail && isSimplified) {
        dispatch(fetchARReportSuccess({data: null}));
      } else {
        dispatch(fetchARReportSuccess(response));
      }
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No Invoices in this Date Range';
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}

export function printARReportBySales(salesId, state, fromDate, toDate, cutoffDate, isSimplified, sortColumn, sortDirection) {
  const mode = isSimplified ? 'simplifiedprint' : 'print';
  return (dispatch) => {
    dispatch({ type: REQUEST_AR_PDF });
    return axios({
      method: 'get',
      url: `${AR_PRINT_URL}${mode}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        start_date: fromDate,
        end_date: toDate,
        cut_off_date: cutoffDate,
        Sales_id: salesId,
        State: state,
        order: (sortDirection === 'DESC' ? '-' : '') + sortColumn
      },
    }).then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'There are no orders in this time range';
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  }
}


export function printPlainARReport(customerId, fromDate, toDate, cutoffDate, mode) {
  return (dispatch) => {
    dispatch({ type: REQUEST_AR_PDF });
    let params = {
      start_date: fromDate,
      end_date: toDate,
    }
    let sq = new Date().getTimezoneOffset();
    if(isLAP || isUSPrideMulti || isAPD) {
      params.time_zone = (-sq / 60)
    }
    if(isOLG) {
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        params.time_zone = zone;
      } else {
        params.time_zone = time;
      }
      params.time_diff = time;
    }
    
    const activeWarehouse =  getLocalStorageData('selectedWarehouse');
    if (isGFD && activeWarehouse) {
      params.warehouse_id = activeWarehouse.value;
    }
    return axios({
      method: 'get',
      url: `${AR_PRINT_PLAIN_URL}${customerId}/${mode}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params,
    }).then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No Invoices in this Date Range';
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}

export function printPlainARReportBySales(salesId, state, fromDate, toDate, cutoffDate, mode, sortColumn, sortDirection) {
  return (dispatch) => {
    dispatch({ type: REQUEST_AR_PDF });
    return axios({
      method: 'get',
      url: `${AR_PRINT_PLAIN_URL}print/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params: {
        start_date: fromDate,
        end_date: toDate,
        Sales_id: salesId,
        State: state,
        cut_off_date: cutoffDate,
        action_ext: mode,
        order: (sortDirection === 'DESC' ? '-' : '') + sortColumn
      },
    }).then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'There are no orders in this time range';
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}

function fetchAPReportSuccess(fileData) {
  return {
    type: FETCH_AP_PDF_SUCCESS,
    payload: fileData,
  };
}

/*
  makes a get request for an AP report and signals for success and failure
  params:
    vendorrId: number,
    fromDate: string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    toDate: string string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    cutoffDate: string in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ),
    isSimplified: boolean
  returns:
    function for thunk middleware
*/
export function printAPReport(vendorId, fromDate, toDate, paymentCutoffDate, isSimplified, activeCompany) {
  const type = isSimplified ? 'simplifiedprint' : 'print';
  const url = `${AP_PRINT_URL}${vendorId}/${type}/`;
  let params = {
    start_date: fromDate,
    end_date: toDate,
    cut_off_date: paymentCutoffDate,
  }
  if(isOLG) {
    let sq = new Date().getTimezoneOffset();
    let time = -sq / 60;
    if(sq > 0 && isDst()) {
      sq+=60;
      let zone = -sq / 60;
      params.time_zone = zone;
    } else {
      params.time_zone = time;
    }
    params.time_diff = time
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_AP_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
      params,
    }).then((response) => {
      dispatch(fetchAPReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No Invoices in this Date Range';
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}

function fetchRoutesPdfSuccess(fileData) {
  return {
    type: REQUEST_ROUTING_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchRoutesPdfFailure(error) {
  return {
    type: REQUEST_ROUTING_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchRoute(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}route/${routeId}/print?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_ROUTING_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchRoutesPdfSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchRoutesPdfFailure(err));             
      }
    });
  };
}

function fetchDispatchPickingListPdfSuccess(fileData) {
  return {
    type: REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchDispatchPickingListPdfFailure(error) {
  return {
    type: REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchPickingList(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}route/${routeId}/print_picking_list?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_DISPATCH_PICKING_LIST_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchDispatchPickingListPdfSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchDispatchPickingListPdfFailure(err));             
      }
    });
  };
}

function fetchDispatchPackingListPdfSuccess(fileData) {
  return {
    type: REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchDispatchPackingListPdfFailure(error) {
  return {
    type: REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchPackingList(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}print_packing_list/${routeId}?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_DISPATCH_PACKING_LIST_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchDispatchPackingListPdfSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchDispatchPackingListPdfFailure(err));             
      }
    });
  };
}

function fetchDispatchSalesInvoicePdfSuccess(fileData) {
  return {
    type: REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS,
    payload: fileData,
  };
}

function fetchDispatchSalesInvoicePdfFailure(error) {
  return {
    type: REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE,
    payload: error,
  };
}

export function printDispatchSalesInvoice(routeId, date) {
  const { fromDate, toDate } = getFromToDates(date);
  const url = `${DISPATCH_URL}route/${routeId}/print_sales_invoice?start_time=${fromDate}&end_time=${toDate}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_DISPATCH_SALES_INVOICE_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchDispatchSalesInvoicePdfSuccess(response));
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchDispatchSalesInvoicePdfFailure(err));             
      }
    });
  };
}

export function printPurchaseReturnNoSubtotals(returnId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL });
    let url = PURCHASE_RETURNS_NO_SUBTOTALS + returnId;
    if(isOLG) {
      let sq = new Date().getTimezoneOffset();
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `?time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `?time_zone=${(time)}&time_diff=${time}`;
      }
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    )
    .then((response) => {
      dispatch(printPurchaseReturnNoSubtotalsSuccess(response));
    }, (err) => {
      console.log('Purchase Return Error', err);
    });
  };
}

export function printPurchaseReturnNoSubtotalsSuccess(fileData) {
  return {
    type: REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS,
    payload: fileData,
  }
}

export function printCommercialInvoicePdf(ids, totalBoxes) {
  return dispatch => {
    dispatch({ type: REQUEST_COMMERCIAL_INVOICE_PDF });
    return axios.get(
      `${PURCHASE_ORDER_PRINT_URL}print/commercial_invoice/`,
      {
        params: { containernum: ids.join(','), total_boxes: totalBoxes},
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    ).then((response) => {
      dispatch({ type: REQUEST_COMMERCIAL_INVOICE_PDF_SUCCESS, payload: response});
    }, (err) => {
      console.log('Purchase Return Error', err);
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch({ type: REQUEST_COMMERCIAL_INVOICE_PDF_FAILURE, payload: err});             
      }
    });
  }
}

export function printPackingListPdf(ids, totalBoxes) {
  return dispatch => {
    dispatch({ type: REQUEST_DISPATCH_PACKING_LIST_PDF});
    return axios.get(
      `${PURCHASE_ORDER_PRINT_URL}print/packing_list/`,
      {
        params: { containernum: ids.join(','), total_boxes: totalBoxes},
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      }
    ).then((response) => {
      dispatch({ type: REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS, payload: response});
    }, (err) => {
      console.log('Purchase Return Error', err);
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch({ type: REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE, payload: err});             
      }
    });
  }
}

export function printARAgedReport(type, PostingDate, ids = [], agedDay, otherParams = {}) {
  let agedDaysParams = agedDay ? `&aged_days=${agedDay || ''}` : null
  let {toDate} = getFromToDates(PostingDate)
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const companyId = selectedCompany ? selectedCompany.value : null;
    let url = `${AR_AGED_PRINT_URL}${type}/?PostingDate=${toDate}`
    if(companyId != null) {
      url = url + `&Company_id=${companyId}`
    }
    if((isLAP || isUSPrideMulti || isAPD) && ids.length > 0) {
      url = url + `&customer_ids=${ids}`
    }
    if((isLAP || isUSPrideMulti || isAPD) && agedDay) {
      url += agedDaysParams
    }
    if(isLAP || isUSPrideMulti || isAPD) {
      let others = Object.keys(otherParams);
      others.map(otherK => {
        url+= `&${otherK}=${otherParams[otherK]}`;
      })
      
    }
    dispatch({ type: REQUEST_AR_PDF });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchARReportSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      } else if (err.status === 400) {
        err.data = 'No AR in this Date Range';
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(err.data));             
      }
    });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/print_actions.js